import { ref } from 'vue'
import { quotesService } from '../../services/quotesService.js'

/**
 * Composable pour charger les données de l'historique
 * Limite: 30 lignes max
 */
export function useQuoteHistoryData(quoteId) {
  const history = ref({ calls: [], automaticEmails: [], statusChanges: [], clientRelances: [] })
  const loadingHistory = ref(false)

  const loadHistory = async () => {
    loadingHistory.value = true
    try {
      const data = await quotesService.getHistory(quoteId)
      history.value = {
        calls: data.calls || [],
        automaticEmails: data.automaticEmails || [],
        statusChanges: data.statusChanges || [],
        clientRelances: data.clientRelances || []
      }
    } catch (err) {
      // On garde l'historique déjà affiché : le vider ferait croire que les
      // appels ont disparu (et rendrait l'aide commerciale « périmée » à tort).
      console.error('Erreur lors du chargement de l\'historique:', err)
    } finally {
      loadingHistory.value = false
    }
  }

  return {
    history,
    loadingHistory,
    loadHistory
  }
}
